import { useEffect, useState } from "react";

// v30 — typewriter nadpis: pri prvom otvorení appky sa text „dopíše" po znakoch
// (kurzor ▍zmizne po dopísaní). animate=false alebo prefers-reduced-motion →
// text sa ukáže naraz. Po dobehnutí zavolá onDone (rodič si zapamätá, že už bolo).
export function Typewriter({ text, speed = 55, animate = true, onDone, style, className }) {
  const reduce = typeof window !== "undefined" && window.matchMedia
    && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const instant = !animate || reduce;
  const [n, setN] = useState(instant ? text.length : 0);
  useEffect(() => {
    if (instant) { setN(text.length); return; }
    setN(0);
    const iv = setInterval(() => setN((v) => (v >= text.length ? v : v + 1)), speed);
    return () => clearInterval(iv);
  }, [text, instant, speed]);
  const done = n >= text.length;
  useEffect(() => { if (done && onDone) onDone(); }, [done]);  // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <span className={className} style={style} aria-label={text}>
      {text.slice(0, n)}
      {!done && <span aria-hidden="true" style={{ opacity: 0.7 }}>▍</span>}
    </span>
  );
}
